import { useContext } from 'react';

import { ThemeContext } from '../globalContext/theme/themeProvider';
import { getBrandLegalUrls } from '../theme/brands/brandLegal';

export const useBrandLegalUrls = () => {
  const [themeState] = useContext(ThemeContext);
  return getBrandLegalUrls(themeState?.brand?.key);
};
